import { createContext } from 'react';

import type {
  DotSeriesToMetadata,
  DotSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export interface DotSeriesDataInternal {
  seriesWithDatapoints: DotSeriesWithDatapoints[];
  seriesToMetadata: DotSeriesToMetadata;
}

export const XYChartDotSeriesDataContext = createContext<
  DotSeriesDataInternal | undefined
>(undefined);

XYChartDotSeriesDataContext['displayName'] = 'XYChartDotSeriesDataContext';
